// extracted by mini-css-extract-plugin
export default {"news-listing":"NewsList_news-listing__UzzkC"};